// Linha do carrinho do Balcão/Totem: foto, nome, observação, quantidade com
// − e + (sem eles em item de etiqueta da balança), total e as etapas agrupadas.
// Usada pela gaveta do Totem (CarrinhoSheet) e pelo painel lateral do Balcão.
import { ImageOff, Minus, Plus, Trash2 } from "lucide-react";

import { agruparEtapas } from "../lib/agruparEtapas";
import { fmt, getImageUrl } from "../lib/helpers";

export default function ItemCarrinho({ item, ctx }) {
  const { products, allProductsForPhotos, removeFromCart, updateCartQty, getItemStepsSummary } = ctx;
  const cid = item.cartItemId || item.id;
  // Subitens agrupados por step_name (Sabores, Borda, Adicionais, etc.)
  const allProds = allProductsForPhotos.length > 0 ? allProductsForPhotos : products;
  const groupedSteps = agruparEtapas(item, allProds, getItemStepsSummary);
  return (
    <div className="bg-zinc-800 rounded-xl p-3 flex flex-col gap-2">
      {/* Header */}
      <div className="flex gap-3">
        <div className="w-16 h-16 rounded-lg overflow-hidden flex-shrink-0 bg-zinc-700">
          {item.photo_url ? <img src={getImageUrl(item.photo_url)} alt={item.name} className="w-full h-full object-cover" /> : <div className="w-full h-full flex items-center justify-center"><ImageOff className="w-6 h-6 text-zinc-500" /></div>}
        </div>
        <div className="flex-1 min-w-0">
          <div className="flex items-start justify-between gap-2">
            <div className="min-w-0">
              <p className="text-sm font-semibold text-zinc-100 leading-tight">{item.name}</p>
              {item.combo_type && <span className="text-[10px] bg-orange-500/20 text-orange-400 px-1.5 py-0.5 rounded font-medium uppercase mt-0.5 inline-block">{item.combo_type}</span>}
            </div>
            <button onClick={() => removeFromCart(cid)} className="p-1 text-zinc-500 hover:text-red-400 flex-shrink-0"><Trash2 className="w-4 h-4" /></button>
          </div>
          {item.observation && <p className="text-[10px] text-zinc-500 mt-1 italic break-words">📝 {item.observation}</p>}
          <div className="flex items-center justify-between mt-2">
            <div className="flex items-center gap-2">
              {!item.etiqueta_balanca && <button onClick={() => updateCartQty(cid, -1)} className="w-7 h-7 rounded-full bg-zinc-700 hover:bg-zinc-600 flex items-center justify-center"><Minus className="w-3 h-3 text-zinc-300" /></button>}
              <span className="text-sm font-bold text-zinc-100 min-w-[1.25rem] text-center">{item.is_divisible || !Number.isInteger(item.quantity) ? item.quantity.toFixed(3).replace('.', ',') : item.quantity}{item.sale_unit && item.sale_unit !== "un" ? <span className="text-[10px] font-normal text-zinc-400 ml-0.5">{item.sale_unit}</span> : null}</span>
              {!item.etiqueta_balanca && <button onClick={() => updateCartQty(cid, 1)} className="w-7 h-7 rounded-full bg-orange-500 hover:bg-orange-600 flex items-center justify-center"><Plus className="w-3 h-3 text-white" /></button>}
            </div>
            <span className="text-sm font-bold text-orange-500">R$ {fmt((item.final_price || item.sale_price) * item.quantity)}</span>
          </div>
        </div>
      </div>

      {/* Subitens agrupados por etapa (com mini-foto, bordas sem foto não mostram placeholder) */}
      {groupedSteps.length > 0 && (
        <div className="space-y-2 mt-1 pl-1">
          {groupedSteps.map((step, gi) => (
            <div key={gi}>
              <p className="text-[9px] font-semibold text-zinc-500 uppercase tracking-wide mb-1">{step.stepName}</p>
              <div className="space-y-1">
                {step.items.map((si, i) => (
                  <div key={i} className="flex items-center gap-2">
                    {si.photo_url && (
                      <div className="w-7 h-7 rounded-md bg-zinc-700 flex-shrink-0 overflow-hidden">
                        <img
                          src={getImageUrl(si.photo_url)}
                          alt=""
                          className="w-full h-full object-cover"
                          onError={(e) => { e.currentTarget.parentElement.style.display = 'none'; }}
                        />
                      </div>
                    )}
                    <div className="flex-1 min-w-0">
                      <p className="text-[11px] text-zinc-300 truncate leading-tight">
                        {si.qty > 1 && <span className="text-zinc-500 mr-0.5">{si.qty}×</span>}
                        {si.name}
                      </p>
                      {si.price != null && si.price > 0 && (
                        <p className="text-[10px] text-orange-500 font-medium leading-tight">R$ {si.price.toFixed(2).replace('.', ',')}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
